<template>
  <div class="content">
    <h1>Coding Class Finalister 2024</h1>
    <main class="finalist-container">

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>EsportDanmark</h3>
          <h4>Simon, Sven og Sylvester<br />7.X, Skolen ved Sundet, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/EDA-GBR">
            <img src="https://cdn.edu.cospaces.io/uploads/p/vj/vj88mFTjzVjUBhOwah7kwGl4DWlsKqstZAA0HkUjCuN" alt="7.X + esportDanmark" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Kyndryl</h3>
          <h4>Tristan, Willy, Karl og Siri<br />6.V, Sølvgades skole, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/JSA-GES">
            <img src="https://cdn.edu.cospaces.io/uploads/p/Zx/Zx4acCHReFgzD0A5xTgM1YWX8EvTAjoN9HycPMgiSy9" alt="Opgave fra Kyndryl" />
          </a>
          
        </div>
      </div>

<div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Wildlife Expedition: Africa</h3>
          <h4>Lærke og Matilda<br />6.D, Tarup Skole, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1028524538/fullscreen/">
            <img src="/static/images/finale/24/tarup.png" alt="Tarup Skole" />
          </a>
          
        </div>
      </div>


      

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Qivittoq</h3>
          <h4>Arnarissoq og Ivinnguaq<br />Atuarfik Jørgen Brønlund, Ilulissat, Grønland</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/985513027/fullscreen/">
            <img src="/static/images/finale/24/groenland.png" alt="Grønland" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Hi3G Denmark i Parken</h3>
          <h4>Emilie, Mati og Victoria<br />6.B, Gerbrandskolen, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/LJY-RMN">
            <img src="https://cdn.edu.cospaces.io/uploads/p/h4/h4veEAvN7wUwlMrv3Ve9cuu7NkHQkz2B5L0c2jXamZq" alt="Hi3G Denmark i Parken" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Det Kongelige Bibliotek</h3>
          <h4>Sara, Smilla og Katinka<br />7.Y, Rådmandsgades skole, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/ZRX-YRQ">
            <img src="https://cdn.edu.cospaces.io/uploads/p/Fe/FeoVNz2OLynpoOoxs1us0sw6rL0BkeJEScmekGuDwma" alt="Det Kongelige Bibliotek" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Scrap Island</h3>
          <h4>Mads og Elias<br />6.B, Skt. Klemensskolen, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1035453931/fullscreen/">
            <img src="/static/images/finale/24/sktklemens.png" alt="Skt Klemensskolen" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Food Clicker</h3>
          <h4>Josefine og Amelia<br />6.B, Kroggaardsskolen, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1029010204/fullscreen//">
            <img src="/static/images/finale/24/kroggaard.png" alt="Kroggaardsskolen" />
          </a>
          
        </div>
      </div>


      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>YouSee</h3>
          <h4>Juliane og Olivia<br />6.U, Sankt Annæ Gymnasium Grundskole, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/CYC-GCW">
            <img src="https://cdn.edu.cospaces.io/uploads/p/lA/lAkyhLzcfuqjhYXWvrh4TpiiuUtMvvSree0vcWp9pEU" alt="YouSee" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>IT Jobbank</h3>
          <h4>Sania, Sabrina, Alexander og Imran<br />6.U, Korsager skole, København</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://edu.cospaces.io/LHD-HLF">
            <img src="https://cdn.edu.cospaces.io/uploads/p/fu/fu1UlBhTMS5YsM7Mu7oznvytw229USMLp4iNa93aYXz" alt="IT Jobbank" />
          </a>
          
        </div>
      </div>

<div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>The Escape</h3>
          <h4>Oscar og Frederik<br />6.A, Næsby Skole, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1029599377/fullscreen/">
            <img src="/static/images/finale/24/naesby.png" alt="Næsby Skole" />
          </a>
          
        </div>
      </div>

      <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Fanget i 2D</h3>
          <h4>Laurits og Noa<br />6.B, Paarup Skole, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1028446829/fullscreen/">
            <img src="/static/images/finale/24/paarup.png" alt="Paarup Skole" />
          </a>
          
        </div>
      </div>

       <div class="finalist-box">
        <div class="finalist-box-inner">
          <h3>Kalle og Planeterne</h3>
          <h4>Lasse og Annika<br />6.A, Munkebjergskolen, Odense</h4>
          <div class="game-summary">
            <p></p>
          </div>
          <p>Tryk på billedet for at prøve</p>
          <a target="_blank" href="https://scratch.mit.edu/projects/1028543626/fullscreen/">
            <img src="/static/images/finale/24/munkebjerg.png" alt="Munkebjergskolen" />
          </a>
          
        </div>
      </div>

    </main>
  </div>
</template>

<script>


export default {
  name: "Finalister",


};
</script>

<style scoped>
.finalist-container {
  margin-top: 32px;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 64px;
}

.finalist-box-inner {
  border-top: 1px solid #2c3e50;
  border-bottom: 1px solid #2c3e50;
  background-color: #f1f1f1;
  padding: 14px 0 24px 0;
}

@media (min-width: 768px) {
  .finalist-container {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 32px;
    column-gap: 32px;
  }

  .finalist-box-inner {
    border-top: none;
    border-bottom: none;
  }
}

.finalist-box-inner h3 {
  font-size: 26px;
  margin: 14px 0;
}


.game-summary {
  text-align: left;
  margin: 14px 0 28px 0;
}

.finalist-box img {
  width: 100%;
}




p {
  margin: 0.5em 1.5em;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/finale/finalister.vue